import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "4a3be9a7-3b99-4d8d-85bd-bd4a6abece78", content: "α = -1.2", options: {} },
  { id: "fd9658a2-0132-419b-a1aa-70c1e6c50494", content: "α = 0.45", options: {} },
  { id: "28de7e64-6300-4933-8ece-c8d9eb377b94", content: "α = 0.55", options: {} },
  { id: "bb05def7-438b-4a43-841d-979b365bac02", content: "α = 0.8", options: {} },
  { id: "b6abf33e-f95d-4cca-8f99-a32e640a0d4a", content: "α = 1.2", options: {} },
  { id: "05a25dd9-13d9-43a5-a5ab-dd16e6b544aa", content: "α = 1.45", options: {} },
];

export const task: Task = {
  id: "34f65c60-fbcb-4eea-ac06-7d05acd4d714",
  solutionType: "select",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: false,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["bb05def7-438b-4a43-841d-979b365bac02"],
};
